export const allowLanguages = ['en', 'de']